import './EditInviteModal.scss'

import React, { Component } from 'react'
import { connectModal } from 'redux-modal'
import { Modal } from 'react-bootstrap'

import {
  cancelBrokerInvite,
  cancelBrokerUserInvite,
  resendBrokerInvite,
  resendBrokerUserInvite
} from 'broker/redux/account'

class EditInvite extends Component {
  constructor(props) {
    super(props)
    this.handleResend = this.handleResend.bind(this)
    this.handleFinish = this.handleFinish.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  invite = this.props.invite

  handleResend() {
    const { contact_type, hash, broker_invite_hash, broker_inbound_hash } = this.invite
    const { dispatch } = this.props

    if (contact_type) {
      dispatch(resendBrokerUserInvite(hash))
        .then(this.handleFinish())
    } else {
      dispatch(resendBrokerInvite(broker_invite_hash, broker_inbound_hash))
        .then(this.handleFinish())
    }
    return true
  }

  handleFinish = () => {
    const { handleHide } = this.props

    handleHide()
  }

  handleCancel = () => {
    const { broker_invite_hash, hash } = this.invite

    if(this.isAgentInvite){
      this.props.dispatch(cancelBrokerInvite(broker_invite_hash))
      .then(this.props.handleHide())
    }else{
      this.props.dispatch(cancelBrokerUserInvite(hash))
      .then(this.props.handleHide())
    }
  }

  isAgentInvite = !this.invite.contact_type

  render() {
    const { email } = this.invite
    const { show } = this.props

    return (
      <Modal className="EditInviteModal" show={show}>
          <Modal.Header className="EditInviteModal__header">
              <Modal.Title className="EditInviteModal__header__title">
                  <div className="EditInviteModal__header__title--text">Edit Invite</div>
                  <div className="EditInviteModal__header__title--close" onClick={this.handleFinish}/>
              </Modal.Title>
          </Modal.Header>

          <Modal.Body className="EditInviteModal__body">
              <div className="EditInviteModal__body--resend-instructions">Choose Resend to send another invite to: {email}</div>
            { this.isAgentInvite ?
              <div className="EditInviteModal__body--cancel-instructions">Choose Cancel Invites to stop this agent from receiving more invite reminder emails.</div> 
              : <div className="EditInviteModal__body--cancel-instructions">Choose Cancel Invites to stop this admin from receiving more invite reminder emails.</div> }
          </Modal.Body>

          <Modal.Footer className="EditInviteModal__footer">
            <div className="EditInviteModal__footer--left">
              <button id="finish-button" onClick={this.handleFinish}>Go Back</button>
            </div>
            <div className="EditInviteModal__footer--right">
              <button id="cancel-invites-button" onClick={this.handleCancel}>Cancel Invite</button> 
              <button id="resend-button" onClick={this.handleResend}>Resend Invite</button>
            </div>
          </Modal.Footer>
      </Modal>
    )
  }
}

const EditInviteModal = connectModal({ name: 'EditInviteModal', destroyOnHide: true })(EditInvite)

export default EditInviteModal
